import React, { useState } from 'react';
import { useHistory } from 'react-router';

import PdfListModal from '../PdfListModal/PdfListModal';

import pdfListApi, { TotalReport } from './pdf-list-api.service';
import redirectIfUnauthorized from '../../core/helpers/redirect-if-unauthorized';

export default function PdfListButton(): JSX.Element {
  const history = useHistory();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [reports, setReports] = useState<TotalReport[]>();

  const loadReports = () => {
    pdfListApi
      .getAllPdf()
      .then((response) => {
        setReports(response);
        setShowModal(true);
      })
      .catch((error) => {
        console.log(error);

        redirectIfUnauthorized(error, history);
      });
  };

  const hideModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <button className="emp-btn" type="button" onClick={loadReports}>
        All reports
      </button>
      {showModal ? (
        <PdfListModal reports={reports} handleClose={hideModal} handleDownload={() => {}} />
      ) : null}
    </>
  );
}
